import * as React from 'react'
import { cn } from '@/lib/utils'

const radioVariants =
  'h-4 w-4 shrink-0 border-[var(--fl-border)] accent-[var(--fl-heading)] cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fl-heading)]/20 disabled:opacity-50 disabled:cursor-not-allowed'

export type RadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(({ className, ...props }, ref) => {
  return <input ref={ref} type="radio" className={cn(radioVariants, className)} {...props} />
})
Radio.displayName = 'Radio'

export { Radio, radioVariants }
